import { render, staticRenderFns } from "./DeleteFeedbackDialog.vue?vue&type=template&id=6376c34c&"
import script from "./DeleteFeedbackDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteFeedbackDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports